export function DoubleChevronDown({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="14"
        height="13"
        viewBox="0 0 14 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.00001 10.1847L2.23627 5.92236L0.68042 7.66126L5.44416 11.9236C5.45445 11.9328 5.4649 11.9421 5.4755 11.9516C5.63183 12.0917 5.82139 12.2615 6.00519 12.3879C6.22881 12.5417 6.56185 12.7174 7.00001 12.7174C7.43818 12.7174 7.77122 12.5417 7.99484 12.3879C8.17864 12.2615 8.3682 12.0917 8.52453 11.9516C8.53513 11.9421 8.54558 11.9328 8.55587 11.9236L13.3196 7.66126L11.7638 5.92236L7.00001 10.1847Z"
          fill="var(--clr-primary-light)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.00001 4.35116L2.23627 0.0888673L0.68042 1.82776L5.44416 6.09006C5.45445 6.09926 5.4649 6.10862 5.4755 6.11812C5.63183 6.25818 5.82139 6.42801 6.00519 6.55439C6.22881 6.70817 6.56185 6.8839 7.00001 6.8839C7.43818 6.8839 7.77122 6.70817 7.99484 6.55439C8.17864 6.42801 8.3682 6.25818 8.52453 6.11812C8.53513 6.10862 8.54558 6.09926 8.55587 6.09006L13.3196 1.82776L11.7638 0.0888677L7.00001 4.35116Z"
          fill="var(--clr-primary-light)"
        />
      </svg>
    </span>
  );
}
